export function formatDateToDDMMYYYY(date: Date | string | null): string {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatarDataDDMMYYYY(data: Date | null, literal: string = '/') {
  if (!data) {
    return null; // Se a data for null, retorna null
  }
  try {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0'); // Adiciona zero à esquerda se necessário
    const dia = data.getDate().toString().padStart(2, '0'); // Adiciona zero à esquerda se necessário
    return `${dia}${literal}${mes}${literal}${ano}`;
  } catch (error) {
    return null; // Se a data for null, retorna null
  }
}

export function formatarDataDDMMYYYYHHMM(dataInput: string | Date, literal: string = '/'): string {
  // Convert the input to a Date object
  let data: Date;

  if (typeof dataInput === 'string') {
    data = new Date(dataInput);
    if (isNaN(data.getTime())) {
      // Check if the date is invalid
      return 'Invalid date';
    }
  } else if (dataInput instanceof Date) {
    data = dataInput;
  } else {
    return 'Invalid date';
  }

  // Extract day, month, year, hours, and minutes
  const dia = ('0' + data.getDate()).slice(-2);
  const mes = ('0' + (data.getMonth() + 1)).slice(-2);
  const ano = data.getFullYear();
  const horas = ('0' + data.getHours()).slice(-2);
  const minutos = ('0' + data.getMinutes()).slice(-2);

  // Return formatted date with the custom separator
  return `${dia}${literal}${mes}${literal}${ano} ${horas}:${minutos}`;
}

export function parseDateDDMMYYYY(dateString: string | null): Date | null {
  if (!dateString) {
    return null; // Se a string for null ou vazia, retorna null
  }

  try {
    const [day, month, year] = dateString.split('/'); // Divide a string

    // Converte os valores de day e month para números
    const dayNum = parseInt(day, 10);
    const monthNum = parseInt(month, 10) - 1; // Mês começa de 0 no JavaScript (Janeiro é 0)
    const yearNum = parseInt(year, 10);

    // Cria e retorna o objeto Date
    return new Date(yearNum, monthNum, dayNum);
  } catch (error) {
    return null;
  }
}

export function formatDateToISO(date: string | Date | null): string {
  if (!date) return '';

  let d: Date;

  if (typeof date === 'string') {
    // Detecta formato dd/MM/yyyy
    const parts = date.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      d = new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      d = new Date(date); // tentativa padrão
    }
  } else {
    d = date;
  }

  if (isNaN(d.getTime())) return '';

  return d.toISOString().split('T')[0]; // retorna yyyy-MM-dd
}

export function formatDateTimeToISO(date: Date | string | null): string {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  return d.toISOString(); // retorna yyyy-MM-ddTHH:mm:ss.sssZ
}
